import React from "react";
import { Box, Typography, TextField, Button, IconButton, Checkbox, Paper } from "@mui/material";
import { BiTrash } from "react-icons/bi";
import PhoneField from "../../../../components/general/PhoneField";

const PublicContactsSection = ({ contacts, onContactsChange, title, isAr, errors = [], onClearError }) => {
  
  const addContact = () => {
    onContactsChange([
      ...contacts,
      { FirstName: "", LastName: "", Email: "", Phone: "", CanPickUp: false, SignedUp: false, ContactType: "", ContactStatus: "" },
    ]);
  };

  const removeContact = (index) => {
    onContactsChange(contacts.filter((_, i) => i !== index));
  };

  const update = (index, key, value) => {
    onContactsChange(contacts.map((c, i) => i === index ? { ...c, [key]: value } : c));
  };

  const label = (ar, en) => isAr ? ar : en;

  return (
    <Box className="info-card mb-4 shadow-sm" sx={{ border: "1px solid #e0e0e0", borderRadius: 2, bgcolor: "white" }}>
      <Box sx={{ p: 2, bgcolor: "#f8f9fa", borderBottom: "1px solid #e0e0e0" }}>
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333" }}>{title}</Typography>
      </Box>

      <Box sx={{ p: 2 }}>
        {contacts.map((contact, index) => (
          <Paper key={index} variant="outlined" sx={{ p: 2, mb: 2, borderRadius: 2, position: "relative" }}>
            {/* Delete button */}
            <IconButton
              color="error" size="small"
              onClick={() => removeContact(index)}
              sx={{ position: "absolute", top: 8, right: isAr ? "auto" : 8, left: isAr ? 8 : "auto" }}
            >
              <BiTrash />
            </IconButton>

            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
              {label("جهة الاتصال", "Contact")} #{index + 1}
            </Typography>

            {/* Name row */}
            <Box display="flex" gap={2} mb={2}>
              <Box flex={1} data-error={errors[index]?.FirstName ? "true" : undefined}>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 0.5, fontWeight: 500 }}>
                  {label("الاسم الأول", "First Name")} <span className="text-danger">*</span>
                </Typography>
                <TextField
                  fullWidth size="small" variant="outlined"
                  value={contact.FirstName}
                  onChange={e => {
                    update(index, "FirstName", e.target.value);
                    if (errors[index]?.FirstName) onClearError?.(index, "FirstName");
                  }}
                  error={!!errors[index]?.FirstName}
                  helperText={errors[index]?.FirstName}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                />
              </Box>
              <Box flex={1}>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 0.5, fontWeight: 500 }}>
                  {label("اسم العائلة", "Last Name")}
                </Typography>
                <TextField
                  fullWidth size="small" variant="outlined"
                  value={contact.LastName}
                  onChange={e => update(index, "LastName", e.target.value)}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                />
              </Box>
            </Box>

            {/* Email + Type row */}
            <Box display="flex" gap={2} mb={2}>
              <Box flex={1}>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 0.5, fontWeight: 500 }}>
                  {label("البريد الإلكتروني", "Email")}
                </Typography>
                <TextField
                  fullWidth size="small" variant="outlined" type="email"
                  value={contact.Email}
                  onChange={e => update(index, "Email", e.target.value)}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                />
              </Box>
              <Box flex={1}>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 0.5, fontWeight: 500 }}>
                  {label("الصلة", "Relationship")}
                </Typography>
                <TextField
                  fullWidth size="small" variant="outlined"
                  value={contact.ContactType}
                  placeholder={label("مثل: والد، أخ...", "e.g. Father, Brother...")}
                  onChange={e => update(index, "ContactType", e.target.value)}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                />
              </Box>
            </Box>

            {/* Phone field */}
            <Box mb={2}>
              <PhoneField
                label={label("رقم الهاتف", "Phone Number")}
                value={contact.Phone}
                onChange={val => update(index, "Phone", val)}
              />
            </Box>

            {/* Checkboxes */}
            <Box display="flex" gap={3} flexWrap="wrap">
              <Box display="flex" alignItems="center" gap={0.5}>
                <Checkbox
                  size="small"
                  checked={contact.CanPickUp}
                  onChange={e => update(index, "CanPickUp", e.target.checked)}
                  sx={{ p: 0.5 }}
                />
                <Typography variant="body2">{label("يمكنه استلام الطفل", "Can pick up child")}</Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={0.5}>
                <Checkbox
                  size="small"
                  checked={contact.SignedUp}
                  onChange={e => update(index, "SignedUp", e.target.checked)}
                  sx={{ p: 0.5 }}
                />
                <Typography variant="body2">{label("مسجَل في التطبيق", "Signed up on app")}</Typography>
              </Box>
            </Box>
          </Paper>
        ))}

        <Button
          onClick={addContact}
          sx={{ color: "#702E8F", fontWeight: 600, textTransform: "none" }}
        >
          + {label("إضافة جهة اتصال", "Add Contact")}
        </Button>
      </Box>
    </Box>
  );
};

export default PublicContactsSection;
